import { useState, useEffect, useRef, useCallback } from 'react'
import styles from './GlimpseSlider.module.css'

const SLIDES = [
  { src: '/centers-glimpse/center-1.jpg', tag: 'Seminar',       title: 'Tech Parivartan Bihar — TP College Seminar', sub: 'Inspiring students to launch their own startups' },
  { src: '/centers-glimpse/center-2.jpg', tag: 'Training',      title: 'Live Classroom — TechHub',                    sub: 'Hands-on, industry-ready skill training' },
  { src: '/centers-glimpse/center-3.jpg', tag: 'College Drive', title: 'Campus Workshop',                             sub: 'Bringing tech education to Tier 2/3/4 colleges' },
  { src: '/centers-glimpse/center-4.jpg', tag: 'TechHub',       title: 'TechHub — Patna',                             sub: 'Work Hard, Let Success — our innovation lab' },
  { src: '/centers-glimpse/center-5.jpg', tag: 'Certification', title: 'Internship Certificate Ceremony',             sub: 'Celebrating our certified interns' },
  { src: '/centers-glimpse/center-6.jpg', tag: 'Talent Hour',   title: 'Ideathon & Awards',                           sub: 'Rewarding the brightest student innovators' },
  { src: '/centers-glimpse/center-7.jpg', tag: 'Office',        title: 'NexusAI Campus',                              sub: 'Our state-of-the-art TechHub facility' },
  { src: '/centers-glimpse/center-8.jpg', tag: 'Event',         title: 'Techphilia 8.0 — Amity University Patna',     sub: 'Ignite Innovation, Embrace the Future' },
]

const AUTO_MS = 4000

export default function GlimpseSlider() {
  const [idx, setIdx] = useState(0)
  const [playing, setPlaying] = useState(true)
  const timer = useRef(null)

  const go = useCallback((n) => setIdx((p) => (n + SLIDES.length) % SLIDES.length), [])

  useEffect(() => {
    if (!playing) return
    timer.current = setInterval(() => setIdx((p) => (p + 1) % SLIDES.length), AUTO_MS)
    return () => clearInterval(timer.current)
  }, [playing])

  const s = SLIDES[idx]

  return (
    <section id="centers" className={styles.section} aria-label="Our Offline Centers Glimpse">
      <div className={styles.inner}>
        <div className={styles.head}>
          <span className={styles.kicker}>✦ On the Ground</span>
          <h2 className={styles.title}>Our Offline Centers, <span className={styles.accent}>Live</span></h2>
          <p className={styles.lead}>
            Real labs, real classrooms, real impact — a glimpse of our TechHubs, seminars and events
            empowering youth across Tier 2, 3 &amp; 4 cities since 2017.
          </p>
        </div>

        <div className={styles.stage}>
          <img key={s.src} src={s.src} alt={s.title} className={styles.slide} loading="lazy" />
          <div className={styles.scrim} />
          <div className={styles.caption}>
            <span className={styles.tag}>{s.tag}</span>
            <h3 className={styles.capTitle}>{s.title}</h3>
            <p className={styles.capSub}>📍 {s.sub}</p>
          </div>

          <button className={`${styles.arrow} ${styles.arrowL}`} onClick={() => go(idx - 1)} aria-label="Previous">‹</button>
          <button className={`${styles.arrow} ${styles.arrowR}`} onClick={() => go(idx + 1)} aria-label="Next">›</button>
          <button className={styles.playBtn} onClick={() => setPlaying((p) => !p)} aria-label={playing ? 'Pause' : 'Play'}>{playing ? '❚❚' : '►'}</button>
          <div className={styles.counter}>{idx + 1} / {SLIDES.length}</div>
        </div>

        <div className={styles.dots}>
          {SLIDES.map((_, i) => (
            <button key={i} onClick={() => go(i)} aria-label={`Slide ${i + 1}`}
              className={`${styles.dot} ${i === idx ? styles.dotActive : ''}`} />
          ))}
        </div>

        <div className={styles.cta}>
          <h3 className={styles.ctaTitle}>Ready to start your tech journey?</h3>
          <p className={styles.ctaLead}>Join 100,000+ students trained since 2017 — learn, intern and get placed with real industry projects.</p>
          <div className={styles.ctaActions}>
            <a href="https://in.nexusaiweb.com" className="btn btn-primary btn-lg" target="_blank" rel="noopener noreferrer">Register Now →</a>
            <a href="#centers" className={styles.ctaGhost}>Explore programs</a>
          </div>
          <p className={styles.ctaNote}>No fees to start · NEP 2020 &amp; NSQF aligned · Patna &amp; Saharsa TechHubs</p>
        </div>
      </div>
    </section>
  )
}
